// ✅ LoginPage.jsx - بازنویسی شده برای بهینه‌سازی و خوانایی
import React, { useState, useEffect, useContext } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { CustomerContext } from "../context/customerContext";
import Swal from "sweetalert2";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logoHaraz from "../assets/Logo-Haraz.png";
import logoZagoo from "../assets/ZAGO-FARSI.png";
import logoAlima from "../assets/ALIMA-FA.png";
import backgroundImage from "../assets/bgImage.png";
import bgImage from "../assets/bgImageMonitorSize.png";
import sideImage from "../assets/chedar.jpg";
import Footer from "./Footer";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [smsMode, setSmsMode] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSmsLogin, setIsSmsLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { fetchCustomerInfo } = useContext(CustomerContext);

  useEffect(() => {
    if (!countdown) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) clearInterval(timer);
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/.test(password);

  const handleLoginWithPassword = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post("/Auth/login", {
        UserName: username,
        PasswordHash: password,
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
        setIsSmsLogin(false);
        if (data.mustChangePassword) setMustChangePassword(true);
        else {
          await fetchCustomerInfo();
          navigate("/dashboard");
        }
      } else alert(data);
    } catch (error) {
      alert("خطا در ورود. لطفاً دوباره تلاش کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendOtp = async () => {
    setCountdown(120);
    try {
      await axios.post("/otp/request", `"${mobile}"`, {
        headers: { "Content-Type": "application/json" },
      });
    } catch (error) {
      if (
        error.response?.status === 400 &&
        error.response.data.includes("موجود نیست")
      ) {
        Swal.fire({
          icon: "error",
          title: "شماره یافت نشد!",
          text: error.response.data,
          showCloseButton: true,
        });
        setMobile("");
        setOtpCode("");
        setSmsMode(false);
        setCountdown(0);
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const { data } = await axios.post("/otp/login", {
        mobile,
        code: otpCode,
      });
      if (data.token) {
        localStorage.setItem("token", data.token);
        setIsSmsLogin(true);
        if (data.mustChangePassword) setMustChangePassword(true);
        else {
          await fetchCustomerInfo();
          navigate("/dashboard");
        }
      } else alert(data);
    } catch (error) {
      alert("خطا در ورود. لطفاً دوباره تلاش کنید.");
    }
  };

  // const handleChangePassword = async () => {
  //   if (newPassword !== confirmPassword) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "عدم تطابق رمز عبور",
  //       text: "رمز عبور و تکرار آن یکسان نیستند.",
  //       showCloseButton: true,
  //     });
  //     return;
  //   }
  //   if (!isValidPassword(newPassword)) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "رمز عبور نامعتبر",
  //       html: "رمز باید حداقل <b>۶ کاراکتر</b> و شامل <b>حروف بزرگ</b>، <b>حروف کوچک</b> و <b>عدد</b> باشد.",
  //       showCloseButton: true,
  //     });
  //     return;
  //   }
  //   try {
  //     const token = localStorage.getItem("token");
  //     await axios.post(
  //       `/Auth/ChangePassword?newPassword=${encodeURIComponent(newPassword)}`,
  //       {},
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  //     await axios.post(
  //       "/Auth/ChangeMustChangePassword",
  //       {},
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     await fetchCustomerInfo();
  //     navigate("/dashboard");
  //   } catch (error) {
  //     alert("خطا در ورود. لطفاً دوباره تلاش کنید.");
  //   }
  // };
  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "عدم تطابق رمز عبور",
        text: "رمز عبور و تکرار آن یکسان نیستند.",
        showCloseButton: true,
      });
      return;
    }

    if (!isValidPassword(newPassword)) {
      Swal.fire({
        icon: "error",
        title: "رمز عبور نامعتبر",
        html: "رمز باید حداقل <b>۶ کاراکتر</b> و شامل <b>حروف بزرگ</b>، <b>حروف کوچک</b> و <b>عدد</b> باشد.",
        showCloseButton: true,
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `/Auth/ChangePassword?newPassword=${encodeURIComponent(newPassword)}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // const baseUrl = isSmsLogin ? "/Otp" : "/Auth";

      // if (isSmsLogin) {
      //   await axios.post(
      //     `${baseUrl}/ChangeMustChangePassword`,
      //     {},
      //     {
      //       headers: { Authorization: `Bearer ${token}` },
      //     }
      //   );
      // }
      // else {
      //   await axios.post(
      //     `${baseUrl}/ChangePassword?newPassword=${encodeURIComponent(
      //       newPassword
      //     )}`,
      //     {},
      //     {
      //       headers: { Authorization: `Bearer ${token}` },
      //     }
      //   );
      // }

      await fetchCustomerInfo();
      navigate("/dashboard");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "تغییر رمز عبور با خطا مواجه شد.",
        showCloseButton: true,
      });
    }
  };

  const renderForm = () => {
    if (mustChangePassword) {
      return (
        <>
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded text-center font-bold text-sm">
            لطفاً رمز عبور خود را تغییر دهید.
          </div>
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="رمز عبور جدید"
              className="w-full p-3 rounded-lg border bg-yellow-100"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <span
              className="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setShowNewPassword((prev) => !prev)}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="تکرار رمز عبور جدید"
              className="w-full p-3 rounded-lg border bg-yellow-100"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span
              className="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button
            type="button"
            className="w-full bg-green-700 text-white py-2 rounded-lg font-bold text-sm mt-2"
            onClick={handleChangePassword}
          >
            ثبت رمز جدید
          </button>
        </>
      );
    }

    if (smsMode) {
      return (
        <>
          <input
            type="tel"
            placeholder="شماره موبایل"
            className="w-full p-3 rounded-lg border bg-yellow-100 text-right"
            value={mobile}
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          />
          <input
            type="text"
            maxLength={4}
            placeholder="کد تأیید"
            className="w-full p-3 rounded-lg border bg-yellow-50 text-center tracking-widest text-sm"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
          />
          <button
            type="button"
            className={`w-full ${otpCode.length === 4
              ? "bg-blue-700 hover:bg-blue-800"
              : "bg-gray-400 cursor-not-allowed"
              } text-white py-2 rounded-lg font-bold text-sm`}
            disabled={otpCode.length !== 4}
            onClick={handleVerifyOtp}
          >
            تأیید کد ورود
          </button>
          <div className="flex justify-between gap-3 mt-2">
            <button
              type="button"
              className={`w-full ${mobile.length === 11 && countdown === 0
                ? "bg-green-600 hover:bg-green-700"
                : "bg-gray-400 cursor-not-allowed"
                } text-white py-2 rounded-lg font-bold text-sm`}
              onClick={handleSendOtp}
            >
              {" "}
              {countdown > 0
                ? `ارسال مجدد تا ${countdown} ثانیه`
                : "ارسال پیامک تأیید"}{" "}
            </button>
            <button
              type="button"
              className="w-full border border-blue-700 text-blue-700 py-2 rounded-lg font-bold text-sm"
              onClick={() => {
                setSmsMode(false);
                setOtpCode("");
                setCountdown(0);
              }}
            >
              بازگشت
            </button>
          </div>
        </>
      );
    }

    return (
      <>
        <input
          type="tel"
          placeholder="نام کاربری (شماره موبایل)"
          className="w-full p-3 rounded-lg border bg-yellow-100 text-right"
          value={username}
          onChange={(e) => setUsername(e.target.value.replace(/\D/g, ""))}
        />
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="رمز عبور"
            className="w-full p-3 rounded-lg border bg-yellow-100"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <div className="flex justify-between gap-3 mt-2">
          <button
            type="submit"
            className="w-1/2 bg-blue-800 text-white py-2 rounded-lg font-bold hover:bg-blue-700 text-sm"
            onClick={handleLoginWithPassword}
          >
            ورود با رمز ثابت
          </button>
          <button
            type="button"
            className="w-1/2 bg-green-600 text-white py-2 rounded-lg font-bold hover:bg-green-700 text-sm"
            onClick={() => {
              setMobile(username);
              setSmsMode(true);
            }}
          >
            ورود با پیامک
          </button>
        </div>
        <div className="m-3 text-right">
          <button
            type="button"
            onClick={() => navigate("/forgot-password")}
            className="text-blue-700 text-sm hover:text-blue-900"
          >
            تغییر رمز عبور
          </button>
        </div>
      </>
    );
  };

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[9999] flex items-center justify-center">
          <div className="loader border-8 border-gray-300 border-t-blue-600 rounded-full w-16 h-16 animate-spin"></div>
        </div>
      )}

      <div className="relative min-h-screen w-full flex items-stretch">
        <img
          src={backgroundImage}
          alt="bg mobile"
          className="absolute inset-0 w-full h-full object-cover z-0 block md:hidden"
        />
        <img
          src={bgImage}
          alt="bg desktop"
          className="absolute inset-0 w-full h-full object-cover z-0 hidden md:block"
        />

        <div className="relative z-10 flex flex-col md:flex-row w-full">
          <div className="hidden md:flex items-center justify-center w-1/2 p-4">
            <div
              className="w-full h-full rounded-2xl overflow-hidden bg-cover bg-center"
              style={{ backgroundImage: `url(${sideImage})` }}
            />
          </div>
          {/* <div className="w-full md:w-1/2 flex items-center justify-center p-4 min-h-screen"> */}

          <div className="w-full md:w-1/2 flex flex-col justify-between items-center p-4 min-h-screen">
            {/* <div className="bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-lg max-w-md w-full text-center m-4"> */}
            <div className="bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-lg max-w-md w-full text-center my-auto">
              <div className="flex justify-center gap-4 mb-6">
                <img
                  src={logoZagoo}
                  alt="Zagoo"
                  className="h-14 mr-3 object-contain"
                />
                <img
                  src={logoAlima}
                  alt="Alima"
                  className="h-14 object-contain"
                />
                <img
                  src={logoHaraz}
                  alt="Haraz"
                  className="h-14 object-contain"
                />
              </div>
              <h2 className="text-xl font-bold text-blue-900 mb-4">
                ورود به پنل مشتریان
              </h2>

              <form
                className="space-y-3 text-right"
                dir="rtl"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!smsMode && !mustChangePassword) {
                    handleLoginWithPassword();
                  }
                }}
              >
                {renderForm()}
              </form>

              {/* )} */}
              <p className="mt-4 text-blue-900 font-bold text-sm">
                لبنیات دوشه آمل
              </p>
            </div>
            <div className="w-full mt-6">
              <Footer />
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
